<script setup lang="ts">
  import { computed } from "vue";
  import { Text } from "../Text";

  const {
    avatar,
    firstName = "",
    lastName = "",
    size = "l",
  } = defineProps<{
    avatar?: string;
    firstName?: string;
    lastName?: string;
    size?: "s" | "m" | "ml" | "l" | "xl";
  }>();

  const initials = computed(() => `${(firstName?.at(0) || "").toUpperCase()}${(lastName?.at(0) || "").toUpperCase() || ""}`);
</script>

<template>
  <div :class="['avatar', size, { 'empty': !initials }]">
    <img v-if="avatar" class="photo" :src="avatar" />
    <Text v-else class="initials" font="body-medium-18" color="white">{{ initials || "?" }}</Text>
  </div>
</template>

<style scoped>
  .avatar {
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 100%;
    background: linear-gradient(var(--sf-success-300), var(--sf-success-600));

    .photo {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    &.empty {
      background: linear-gradient(var(--sf-alt-100), var(--sf-alt-300));
    }

    &.l {
      width: 54px;
      height: 54px;

      span.initials {
        font-size: 18px;
      }
    }

    &.xl {
      width: 116px;
      height: 116px;

      span.initials {
        font-size: 36px;
      }
    }

    &.m {
      width: 30px;
      height: 30px;

      span.initials {
        font-size: 12px;
      }
    }

    &.s {
      width: 24px;
      height: 24px;

      span.initials {
        font-size: 10px;
      }
    }

    &.ml {
      width: 42px;
      height: 42px;

      span.initials {
        font-size: 16px;
      }
    }
  }
</style>
